export default __webpack_public_path__ + "static/media/ic_check.f357994b.svg";